/**
 * Focus ring thickness/offset for keyboard and text-field focus.
 * Applied as CSS vars `--focus-outline-width` / `--focus-outline-offset`.
 */

export const FOCUS_OUTLINE_WIDTH_MIN = 1;
export const FOCUS_OUTLINE_WIDTH_MAX = 6;
export const FOCUS_OUTLINE_OFFSET_MIN = 0;
export const FOCUS_OUTLINE_OFFSET_MAX = 8;

/** Smaller than the old hard-coded 3/3 — still visible for a11y. */
export const DEFAULT_FOCUS_OUTLINE = {
  widthPx: 2,
  offsetPx: 2,
};

function clampInt(raw, min, max, fallback) {
  const n = Number(raw);
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, Math.round(n)));
}

/**
 * @param {unknown} raw
 * @returns {{ widthPx: number, offsetPx: number }}
 */
export function normalizeFocusOutline(raw) {
  const source =
    raw && typeof raw === 'object' && !Array.isArray(raw)
      ? /** @type {Record<string, unknown>} */ (raw)
      : {};
  return {
    widthPx: clampInt(
      source.widthPx ?? source.width_px ?? source.width,
      FOCUS_OUTLINE_WIDTH_MIN,
      FOCUS_OUTLINE_WIDTH_MAX,
      DEFAULT_FOCUS_OUTLINE.widthPx,
    ),
    offsetPx: clampInt(
      source.offsetPx ?? source.offset_px ?? source.offset,
      FOCUS_OUTLINE_OFFSET_MIN,
      FOCUS_OUTLINE_OFFSET_MAX,
      DEFAULT_FOCUS_OUTLINE.offsetPx,
    ),
  };
}

/**
 * @param {{ widthPx: number, offsetPx: number }} outline
 * @returns {{ width: string, offset: string }}
 */
export function focusOutlineCssVars(outline) {
  return {
    width: `${outline.widthPx}px`,
    offset: `${outline.offsetPx}px`,
  };
}
